module.exports = __webpack_public_path__ + "catalog/items/firesafety/direction-diagonal-bottom-left/direction-diagonal-bottom-left.svg";